import './structureDataSource.css'

import React from 'react'
import DateTimeCell from 'revenue/RevenueDetails/DateTimeCell'
import { storeNameColumn } from 'TableCommon/defaultColumns'
import type { HeaderAdditionalComponentProps } from 'TableCommon/TableCommonHeader'

import Box from '@mui/material/Box'

import { REVENUE_SORT_COLUMNS } from './constants'

interface Props {
  shareData: {
    isCumulative: boolean
  }
  store: {
    dataSource?: string
    exposTimestamp?: string | null
    resaTimestamp?: string | null
    trafficTimestamp?: string | null
  }
}

export default [
  storeNameColumn,
  {
    id: REVENUE_SORT_COLUMNS.RESA_TIMESTAMP,
    classNameHeader: 'cell-resa',
    classNameRow: 'cell cell-resa',
    translation: ['tableSourceData.resa'],
    RowRenderer: ({ shareData, store }: Props) => (
      <DateTimeCell datetime={store.resaTimestamp} isCumulative={shareData.isCumulative} />
    ),
  },
  {
    id: REVENUE_SORT_COLUMNS.EXPOS_TIMESTAMP,
    classNameHeader: 'cell-expos',
    classNameRow: 'cell cell-expos',
    translation: ['tableSourceData.expos'],
    RowRenderer: ({ shareData, store }: Props) => (
      <DateTimeCell datetime={store.exposTimestamp} isCumulative={shareData.isCumulative} />
    ),
  },
  {
    id: REVENUE_SORT_COLUMNS.TRAFFIC_TIMESTAMP,
    classNameHeader: 'cell-traffic',
    classNameRow: 'cell cell-traffic',
    translation: ['tableSourceData.traffic'],
    RowRenderer: ({ shareData, store }: Props) => (
      <DateTimeCell datetime={store.trafficTimestamp} isCumulative={shareData.isCumulative} />
    ),
  },
  {
    id: REVENUE_SORT_COLUMNS.DATA_SOURCE,
    classNameHeader: 'cell-data-source',
    classNameRow: 'cell cell-data-source',
    HeaderAdditionalComponent: ({ id, onFilter }: HeaderAdditionalComponentProps) => (
      <Box display="inline" className="fm fm-database" onClick={onFilter} data-value={id} />
    ),
    hideDefaultHeader: true,
    RowRenderer: ({ store }: Props) => store.dataSource,
  },
]
